import {
  constants,
} from '@newsela/angelou';
import {css} from 'emotion';

import fonts from 'static/three-oh/src/modules/constants/fonts';

const colors = constants.colors;

const searchForm = (isDesktopDisplay) => {
  const margin = isDesktopDisplay ? '5px 0 0 0' : '25px 25px 15px 17px';

  return css`
    display: flex;
    align-items: center;
    margin-top: 5px;
    margin: ${margin};
    caret-color: ${colors.ui.greyDark['500']};
  `;
};

const searchInput = (isDesktopDisplay) => {
  const fontSize = isDesktopDisplay ? '1.7rem' : fonts.sizes.l;

  return css`
    height: ${fonts.sizes.xxl};
    width: 380px;
    font-size: ${fontSize};
    font-family: Circular, Helvetica, Arial, sans-serif;
    color: ${colors.ui.greyDark['500']};
    caret-color: ${colors.ui.greyDark['500']};
    border-color: ${colors.brand.greyDark['500']};
    outline: 0;
    border-width: 0 0 2px;
    font-weight: 700;
    flex: 1;
    min-width: 0;
    -webkit-appearance: none;
    text-overflow: ellipsis;
    margin-right: 9px;
    padding-left: 10px;

    &::placeholder {
      color: ${colors.ui.greyLight['500']};
    }
  `;
};

const searchIcon = () => {
  return css`
    font-size: ${fonts.sizes.m};
    height: ${fonts.sizes.xxl};
    display: flex;
    align-items: center;
    padding-right: 5px;
    border-bottom: 2px solid ${colors.brand.greyDark['500']};
    margin-left: 1px;
  `;
};

const timesIconContainer = css`
  &&& {
    background-color: ${colors.ui.grey['100']};
    padding: 1px 6px;
    cursor: pointer;
    border-color: ${colors.ui.grey['100']};
  }
`;

const timesIcon = css`
   font-size: ${fonts.sizes.l};
   color: ${colors.ui.white['700']};
`;

const cancelButton = css`
  &&& {
    color: ${colors.ui.grey['700']};
    padding: 0.5rem 1rem;
    font-family: ${fonts.circular.normal};
    font-weight: 700;
    font-size: ${fonts.sizes.s};

    &:hover, &:focus {
      background-color: ${colors.ui.white['700']};
      color: ${colors.ui.greyDark['700']};
    };
  }
`;

export default {
  cancelButton,
  searchForm,
  searchInput,
  searchIcon,
  timesIcon,
  timesIconContainer,
};
